import React from "react";
import {
  Wrench,
  RefreshCcw,
  Layers,
  Lightbulb,
  BookOpen,
  ShieldCheck,
  Repeat2,
  CircuitBoard,
} from "lucide-react";

const engagementAreas = [
  {
    title: "New Product Development",
    icon: <Lightbulb className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Indigenization",
    icon: <ShieldCheck className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Product Upgradation",
    icon: <RefreshCcw className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Value Engineering",
    icon: <Layers className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Reverse Engineering",
    icon: <Repeat2 className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Troubleshooting",
    icon: <Wrench className="h-6 w-6 text-emerald-600" />,
  },
  {
    title: "Study of SAE / ARAI Standards",
    icon: <BookOpen className="h-6 w-6 text-emerald-600" />,
  },
];

const ElectricalDesign = () => {
  return (
    <section className="bg-gradient-to-br from-white via-blue-gray-200 to-blue-gray-200 border-t-4 border-emerald-600 py-20 px-6 md:px-16">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-emerald-100 p-4 rounded-full shadow-md">
            <CircuitBoard className="h-8 w-8 text-emerald-700" />
          </div>
        </div>

        {/* Heading & Text */}
        <h2 className="text-4xl font-bold text-emerald-700 mb-4">
          ELECTRICAL DESIGN – AUTOMOBILE ENGINEERING
        </h2>
        <p className="text-gray-800 text-lg mb-6 font-semibold">
          iNVORA TECHNOLOGY PRIVATE LIMITED has expertise in designing
          cutting-edge electrical systems for the automotive sector.
        </p>
        <p className="text-gray-700 mb-4">
          Our innovative processes ensure precision in every new product design.
          <br /> We listen closely to clients and end-users to deliver relevant,
          imaginative solutions that meet expectations.
        </p>
        <p className="text-gray-700 mb-12">
          We offer value-added services in the design and redesign of electrical
          systems and participate in all phases of electrical design
          development.
        </p>
        <p className="text-gray-900  text-left text-xl mb-12">
          <strong className="text-blue-800  text-4xl">| </strong> Our key engagement areas include:
        </p>

        {/* Horizontal Timeline Without Scroll */}
        <div className="relative w-full">
          {/* Horizontal line */}
          <div className="absolute top-7 left-0 w-full h-1 bg-emerald-500 z-0"></div>

          {/* Timeline Items */}
          <div className="flex flex-wrap justify-between gap-y-10 relative z-10">
            {engagementAreas.map((area, index) => (
              <div
                key={index}
                className="flex flex-col items-center w-[120px] mx-auto md:mx-0"
              >
                <div className="bg-white border-4 border-emerald-500 rounded-full p-3 shadow-md z-10">
                  {area.icon}
                </div>
                <div className="mt-4 text-sm font-medium text-gray-900 text-center">
                  {area.title}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElectricalDesign;
